<template>
  <div class="product-page">
    <div :class="{ 'product-menu-container': !isLoggedIn }">
      <div class="nav-bg"></div>
      <div class="product-menu">
        <div class="product-menu-title">
          {{
            currentLanguage === "en"
              ? product.productNameEn
              : product.productName
          }}
        </div>
      </div>

      <div class="product-menu-items">
        <!-- <div
          class="product-menu-item"
          v-for="template in templates"
          :key="template.id"
          @click="handleClick(template)"
        >
          {{ template.keywords }}
        </div> -->
      </div>
    </div>
    <!-- <div class="product-header">
      <h1>{{ product.productName }}</h1>
    </div> -->

    <div class="product-content">
      <!-- 产品图片 -->
      <!-- <div class="product-image-container" v-if="product.mainImage">
        <img
          :src="product.mainImage"
          :alt="product.productName"
          class="product-image"
        />
      </div> -->
      <el-popover
        v-model:visible="visible"
        ref="popoverRef"
        :virtual-ref="triggerRef"
        trigger="click"
        title="输入序号"
        virtual-triggering
        placement="left-start"
        width="200px"
      >
        <el-input-number
          v-model="inputValue"
          placeholder="请输入序号"
        ></el-input-number>
        <el-button style="margin-top: 8px" type="primary" @click="handleUpdate"
          >确定</el-button
        >
      </el-popover>
      <!-- 产品模板列表 -->
      <div class="templates-section" v-if="templates.length > 0">
        <div class="templates-list">
          <div
            :id="template.id"
            v-for="template in templates"
            :key="template.id"
            class="template-card"
          >
            <!-- <div style="height: 100%; width: 100%; background-color: #f5f5f5;"></div> -->
            <component
              :is="template.templateName"
              :template-id="template.id"
              @handleDelete="handleDelete"
              @order="handleOrder($event, template, isContent)"
              @contentOrder="handleContentOrder"
            ></component>
          </div>
        </div>
      </div>

      <!-- 无模板提示 -->
      <!-- <div class="no-templates" v-else-if="!loading">
        <p>{{ t('product.page.noTemplates') }}</p>
      </div> -->

      <!-- 创建模板按钮 -->
      <div
        class="create-template-section"
        v-if="!loading && isLoggedIn"
        @click="showCreateDialog = true"
      >
        <el-icon><Plus /></el-icon>{{ t("product.page.createTemplate") }}
      </div>

      <!-- 加载状态 -->
      <!-- <div class="loading-container" v-loading="loading">
        <p>加载中...</p>
      </div> -->
    </div>

    <!-- 创建模板对话框 -->
    <el-dialog
      v-model="showCreateDialog"
      :title="t('product.page.createDialogTitle')"
      width="80%"
      fullscreen
    >
      <el-form :model="templateForm" :rules="formRules" ref="templateFormRef">
        <el-form-item
          :label="t('product.page.templateSelection')"
          prop="templateName"
        >
          <div class="template-image-selection">
            <div
              class="template-image-item"
              :class="{ selected: templateForm.templateName === 'Template1' }"
              @click="selectTemplate('Template1')"
            >
              <img
                :src="template1Image"
                alt="Template1"
                class="template-image"
              />
              <div
                class="selected-indicator"
                v-if="templateForm.templateName === 'Template1'"
              >
                ✓
              </div>
            </div>
            <div
              class="template-image-item"
              :class="{ selected: templateForm.templateName === 'Template2' }"
              @click="selectTemplate('Template2')"
            >
              <img
                :src="template2Image"
                alt="Template2"
                class="template-image"
              />
              <div
                class="selected-indicator"
                v-if="templateForm.templateName === 'Template2'"
              >
                ✓
              </div>
            </div>
            <div
              class="template-image-item"
              :class="{ selected: templateForm.templateName === 'Template3' }"
              @click="selectTemplate('Template3')"
            >
              <img
                :src="template3Image"
                alt="Template3"
                class="template-image"
              />
              <div
                class="selected-indicator"
                v-if="templateForm.templateName === 'Template3'"
              >
                ✓
              </div>
            </div>
            <div
              class="template-image-item"
              :class="{ selected: templateForm.templateName === 'Template4' }"
              @click="selectTemplate('Template4')"
            >
              <img
                :src="template4Image"
                alt="Template4"
                class="template-image"
              />
              <div
                class="selected-indicator"
                v-if="templateForm.templateName === 'Template4'"
              >
                ✓
              </div>
            </div>
            <div
              class="template-image-item"
              :class="{ selected: templateForm.templateName === 'Template5' }"
              @click="selectTemplate('Template5')"
            >
              <img
                :src="template5Image"
                alt="Template5"
                class="template-image"
              />
              <div
                class="selected-indicator"
                v-if="templateForm.templateName === 'Template5'"
              >
                ✓
              </div>
            </div>
            <div
              class="template-image-item"
              :class="{ selected: templateForm.templateName === 'Template6' }"
              @click="selectTemplate('Template6')"
            >
              <img
                :src="template6Image"
                alt="Template6"
                class="template-image"
              />
              <div
                class="selected-indicator"
                v-if="templateForm.templateName === 'Template6'"
              >
                ✓
              </div>
            </div>
            <div
              class="template-image-item"
              :class="{ selected: templateForm.templateName === 'Template7' }"
              @click="selectTemplate('Template7')"
            >
              <img
                :src="template7Image"
                alt="Template7"
                class="template-image"
              />
              <div
                class="selected-indicator"
                v-if="templateForm.templateName === 'Template7'"
              >
                ✓
              </div>
            </div>
            <div
              class="template-image-item"
              :class="{ selected: templateForm.templateName === 'Template8' }"
              @click="selectTemplate('Template8')"
            >
              <img
                :src="template8Image"
                alt="Template8"
                class="template-image"
              />
              <div
                class="selected-indicator"
                v-if="templateForm.templateName === 'Template8'"
              >
                ✓
              </div>
            </div>
          </div>
        </el-form-item>
        <!-- <el-form-item label="关键词" prop="keywords">
          <el-input
            v-model="templateForm.keywords"
            placeholder="请输入关键词"
          />
        </el-form-item> -->
      </el-form>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="showCreateDialog = false">{{
            t("product.page.cancel")
          }}</el-button>
          <el-button type="primary" @click="handleCreateTemplate">{{
            t("product.page.confirmCreate")
          }}</el-button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import api from "../api";
import { ref, onMounted, reactive, inject, computed, watch } from "vue";
import { useRoute } from "vue-router";
import { ElMessage, ElMessageBox } from "element-plus";
import { useI18n } from "vue-i18n";
import template1Image from "../assets/template1.png";
import template2Image from "../assets/template2.png";
import template3Image from "../assets/template3.png";
import template4Image from "../assets/template4.png";
import template5Image from "../assets/template5.png";
import template6Image from "../assets/template6.png";
import template7Image from "../assets/template7.png";
import template8Image from "../assets/template8.png";

import Template1 from "../components/Template1.vue";
import Template2 from "../components/Template2.vue";
import Template3 from "../components/Template3.vue";
import Template4 from "../components/Template4.vue";
import Template5 from "../components/Template5.vue";
import Template6 from "../components/Template6.vue";
import Template7 from "../components/Template7.vue";
import Template8 from "../components/Template8.vue";
import productAPI from "../api/modules/product";
import contentAPI from "../api/modules/content";

export default {
  name: "ProductPage",
  components: {
    Template1,
    Template2,
    Template3,
    Template4,
    Template5,
    Template6,
    Template7,
    Template8,
  },
  inject: ["currentLanguage"],
  setup() {
    const { t } = useI18n();
    const route = useRoute();
    const product = ref({});
    const templates = ref([]);
    const loading = ref(true);
    const showCreateDialog = ref(false);
    const templateFormRef = ref();
    const productId = computed(() => route.params.id);
    const contentMap = inject("contentMap");
    const updatecontentMap = inject("updatecontentMap");
    const inputValue = ref(0);
    const selectedTemplate = ref(null);
    const position = ref({
      top: 0,
      left: 0,
      bottom: 0,
      right: 0,
    });
    const isContent = ref(false);
    const tempData = ref({});
    const visible = ref(false);
    const triggerRef = ref({
      getBoundingClientRect: () => position.value,
    });
    const mousemoveHandler = ({ clientX, clientY }) => {
      position.value = DOMRect.fromRect({
        x: clientX,
        y: clientY,
      });
    };
    const handleContentOrder = (event, contentId) => {
      const { clientX, clientY } = event;
      visible.value = true;
      position.value = DOMRect.fromRect({
        x: clientX,
        y: clientY,
      });
      isContent.value = true;
      tempData.value = contentMap.value[contentId];
      inputValue.value = tempData.value.orderNum || 0;
      selectedTemplate.value = contentId;
    };
    const handleOrder = (event, data) => {
      const { clientX, clientY } = event;
      visible.value = true;
      position.value = DOMRect.fromRect({
        x: clientX,
        y: clientY,
      });
      isContent.value = false;
      inputValue.value = data.orderNum;
      selectedTemplate.value = data.id;
    };
    watch(productId, async (newId) => {
      if (newId) {
        loading.value = true;
        // 先获取产品信息
        await fetchProductInfo();
        // 再获取模板信息
        await fetchProductTemplates();
        loading.value = false;
      }
    });
    // 模板表单数据
    const templateForm = reactive({
      templateName: "Template1",
      keywords: "",
    });
    const isLoggedIn = inject("isLoggedIn");
    // 表单验证规则
    const formRules = {
      templateName: [
        {
          required: true,
          message: t("product.page.templateSelection"),
          trigger: "change",
        },
      ],
      // keywords: [
      //   { required: true, message: t('product.page.keywordsPlaceholder'), trigger: "blur" },
      //   {
      //     min: 1,
      //     max: 200,
      //     message: t('product.page.keywordsLengthLimit'),
      //     trigger: "blur",
      //   },
      // ],
    };
    const handleUpdate = () => {
      if (isContent.value) {
        const data = JSON.stringify({
          ...tempData.value,
          orderNum: inputValue.value,
        })
        contentAPI
          .updateContent({  contentId: selectedTemplate.value, contentText: data })
          .then((data) => {
            // 可以添加更新成功后的处理，比如刷新页面或提示用户
            if (data.success) {
              visible.value = false;
              updatecontentMap();
              ElMessage.success(t("product.page.updateSuccess"));
            } else {
              ElMessage.error(data.message || t("product.page.updateFailed"));
            }
          });
      } else {
        // 调用更新模板接口
        productAPI
          .updateContainer(selectedTemplate.value, {
            orderNum: inputValue.value,
          })
          .then((data) => {
            // 可以添加更新成功后的处理，比如刷新页面或提示用户
            if (data.success) {
              visible.value = false;
              fetchProductTemplates();
              ElMessage.success(t("product.page.updateSuccess"));
            } else {
              ElMessage.error(data.message || t("product.page.updateFailed"));
            }
          })
          .catch((error) => {
            // 处理更新失败的情况
            ElMessageBox.alert(
              t("product.page.updateFailedAlert"),
              t("product.page.errorTitle"),
              {
                confirmButtonText: t("product.page.confirm"),
                type: "error",
              },
            );
            console.error(t("product.errors.updateTemplateFailed"), error);
          });
      }
    };
    // 处理删除事件
    const handleDelete = (templateId) => {
      // 确认是否删除该模板,使用element-plus的确认弹窗
      ElMessageBox.confirm(
        t("product.page.deleteConfirm"),
        t("product.page.deleteConfirmTitle"),
        {
          confirmButtonText: t("product.page.confirm"),
          cancelButtonText: t("product.page.cancel"),
          type: "warning",
        },
      )
        .then(() => {
          //调用删除模板接口
          productAPI
            .deleteContainer(templateId)
            .then((data) => {
              // 可以添加删除成功后的处理，比如刷新页面或提示用户
              if (data.success) {
                fetchProductTemplates();
                ElMessage.success(t("product.page.deleteSuccess"));
              } else {
                ElMessage.error(data.message || t("product.page.deleteFailed"));
              }
            })
            .catch((error) => {
              // 处理删除失败的情况
              ElMessageBox.alert(
                t("product.page.deleteFailedAlert"),
                t("product.page.errorTitle"),
                {
                  confirmButtonText: t("product.page.confirm"),
                  type: "error",
                },
              );
              console.error(t("product.errors.deleteTemplateFailed"), error);
            });
        })
        .catch(() => {
          // 用户点击了取消，不执行任何操作
        });
    };

    // 获取产品信息
    const fetchProductInfo = async () => {
      try {
        // 从路由参数中获取产品ID
        const productId = route.params.id;
        if (!productId) {
          console.error(t("product.errors.productIdNotFound"));
          loading.value = false;
          return;
        }

        // 调用API获取产品详情
        const response = await api.product.getProduct(productId);
        if (response.success) {
          product.value = response.data || {};
        } else {
          console.error(
            t("product.errors.fetchProductInfoFailed"),
            response.message,
          );
        }
      } catch (error) {
        console.error(t("product.errors.fetchProductInfoError"), error);
      } finally {
        // 完成产品信息获取后，获取模板信息
        loading.value = false;
      }
    };

    // 获取产品下属模板
    const fetchProductTemplates = async () => {
      try {
        const productId = route.params.id;
        if (!productId) {
          console.error(t("product.errors.productIdNotFound"));
          return;
        }

        // 调用API获取产品模板
        // 注意：这里假设API中有getTemplatesByProductId方法，如果没有需要在API模块中添加
        const response = await api.product.getTemplatesByProductId(productId);
        if (response.success) {
          templates.value = response.data || [];
        } else {
          console.error(
            t("product.errors.fetchTemplatesFailed"),
            response.message,
          );
        }
      } catch (error) {
        console.error(t("product.errors.fetchTemplatesError"), error);
      }
    };

    // 组件挂载时调用
    onMounted(async () => {
      loading.value = true;
      // 先获取产品信息
      await fetchProductInfo();
      // 再获取模板信息
      await fetchProductTemplates();
      loading.value = false;
    });
    window.addEventListener("scroll", () => {
      visible.value = false;
    });

    // 选择模板
    const selectTemplate = (templateName) => {
      templateForm.templateName = templateName;
    };
    const handleClick = (template) => {
      // 下滑到对应章节
      const element = document.getElementById(template.id);
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    };
    // 创建模板
    const handleCreateTemplate = async () => {
      // 表单验证
      templateFormRef.value.validate(async (valid) => {
        if (valid) {
          try {
            const productId = route.params.id;
            const response = await api.product.createTemplate(
              productId,
              templateForm,
            );

            if (response.success) {
              ElMessage.success(t("product.page.templateCreatedSuccess"));
              showCreateDialog.value = false;

              // 重置表单
              templateFormRef.value.resetFields();
              await updatecontentMap();
              // 重新获取模板列表
              await fetchProductTemplates();
            } else {
              ElMessage.error(
                t("product.page.templateCreateFailed") +
                  (response.message || "未知错误"),
              );
            }
          } catch (error) {
            console.error("创建模板出错:", error);
            ElMessage.error(t("product.errors.createTemplateFailed"));
          }
        }
      });
    };

    return {
      product,
      templates,
      loading,
      showCreateDialog,
      templateForm,
      templateFormRef,
      formRules,
      template1Image,
      template2Image,
      template3Image,
      template4Image,
      template5Image,
      template6Image,
      template7Image,
      template8Image,
      isLoggedIn,
      triggerRef,
      handleOrder,
      visible,
      inputValue,
      t,
      viewTemplate: (templateId) => {
        console.log("查看模板:", templateId);
        // 这里可以添加查看模板的逻辑
      },
      selectTemplate,
      handleCreateTemplate,
      handleDelete,
      handleUpdate,
      handleClick,
      handleContentOrder,
    };
  },
};
</script>

<style scoped>
/* PC端样式 */
@media (min-width: 769px) {
  .product-menu-container {
    position: absolute;
    top: 0px;
    left: 0;
    width: 100%;
    z-index: 999;
  }
}

.product-menu {
  display: flex;
  justify-content: space-between;
  height: 40px;
  line-height: 40px;
  color: #fff;
  background: #222;
  border-top: 1px solid rgba(255, 255, 255, 0.2);
  padding: 0px 4.17vw;
  position: sticky;
  top: 0;
}
.product-menu-title {
  font-size: 18px;
  font-weight: bold;
}
.product-menu-items {
  display: flex;
  gap: 16px;
}
.product-menu-item {
  cursor: pointer;
}
.nav-bg {
  height: 70px;
  width: 100%;
  background: #222;
}
.product-page {
  /* max-width: 1200px; */
  margin: 0 auto;
  /* padding: 20px; */
}

.template-image-selection {
  display: flex;
  gap: 20px;
  margin-top: 10px;
  flex-wrap: wrap;
}

.template-image-item {
  width: calc(50% - 10px);
  /* max-width: 200px; */
  border: 2px solid #dcdfe6;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s ease;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 10px;
  box-sizing: border-box;
}

.template-image-item:hover {
  border-color: #409eff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.template-image-item.selected {
  border-color: #409eff;
  background-color: #ecf5ff;
  box-shadow: 0 0 0 2px rgba(64, 158, 255, 0.2);
}

.template-image {
  width: 100%;
  min-height: 180px;
  object-fit: contain;
  border-radius: 4px;
  background-color: #f5f7fa;
  display: block;
  margin: 0 auto;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .template-image-item {
    width: 100%;
    max-width: none;
  }

  /* 移动端隐藏product-menu-container */
  /* .product-menu-container {
    display: none;
  } */
}

.template-name {
  color: #303133;
  font-size: 14px;
  font-weight: 500;
}

.selected-indicator {
  position: absolute;
  top: 8px;
  right: 8px;
  width: 24px;
  height: 24px;
  background-color: #409eff;
  color: white;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  font-weight: bold;
}

.product-header {
  text-align: center;
  /* margin-bottom: 40px; */
}

.product-header h1 {
  color: #333;
  font-size: 2.5rem;
  margin-bottom: 10px;
}

.product-description {
  color: #666;
  font-size: 1.1rem;
  max-width: 800px;
  margin: 0 auto;
}

.product-content {
  /* display: flex;
  flex-direction: column;
  min-height: 800px; */
  /* gap: 40px; */
}

.product-image-container {
  text-align: center;
  margin: 30px 12px;
}

.product-image {
  max-width: 100%;
  height: auto;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.templates-section {
  /* margin-top: 40px; */
}

.templates-section h2 {
  color: #333;
  margin-bottom: 20px;
  font-size: 1.8rem;
}

.templates-list {
  width: 100%;
  margin: 0;
  padding: 0;
}

.templates-list > .template-card {
  width: 100vw;
  margin: 0;
  border: none;
  border-radius: 0;
  padding: 0;
  box-shadow: none;
}

.template-card {
  /* border: 1px solid #e0e0e0; */
  /* border-radius: 8px; */
  /* padding: 20px; */
  transition: all 0.3s ease;
  background: #fff;
  position: relative;
}

.template-card:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  /* transform: translateY(-2px); */
}

.template-card h3 {
  margin-top: 0;
  color: #333;
  font-size: 1.2rem;
  margin-bottom: 10px;
}

.template-keywords {
  color: #666;
  margin-bottom: 15px;
}

.loading-container {
  text-align: center;
  padding: 60px 20px;
}

.no-templates {
  text-align: center;
  padding: 40px 20px;
  color: #666;
  font-size: 16px;
}

.create-template-section {
  margin: 30px 12px;
  text-align: center;
  padding: 20px;
  background-color: #fafafa;
  border-radius: 8px;
  border: 1px dashed #d9d9d9;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  font-size: 16px;
  color: #333;
}

.create-template-section:hover {
  background-color: #f0f9ff;
  border-color: #409eff;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.create-template-section:active {
  transform: translateY(0);
}

/* 响应式设计 */
@media (max-width: 768px) {
  .create-template-section {
    margin: 20px 8px;
    padding: 15px;
    font-size: 14px;
  }
}

@media (min-width: 769px) and (max-width: 1100px) {
  .create-template-section {
    margin: 25px 16px;
    padding: 18px;
  }
}

.dialog-footer {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
}
</style>
